import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import PrivateRoute from "components/authentication/PrivateRoute";
import ScrollToTop from "components/common/ScrollToTop";
import HomePage from "components/main/home/HomePage";
import ProfilePage from "components/authentication/profile/ProfilePage";
import UnderConstruction from "components/common/UnderConstruction";
import NotFoundPage from "components/common/NotFoundPage";
import NotPermittedPage from "components/common/NotPermittedPage";
import { PermissionTypes } from "components/authentication/permissionsGroups";
import SignIn from "components/authentication/SignIn";
import ChangePassword from "components/authentication/ChangePasswordPage";
import ForgotPassword from "components/authentication/ForgotPassword";
import ResetPasswordPage from "components/authentication/ResetPasswordPage";
import WellComePage from "components/authentication/WellComePage";
import TicketsPage from "components/ticketing/TicketsPage";
import OdPLegacyPage from "./main/produzione/OdPLegacyPage";
import SchedulazionePage from "./main/schedulazione/SchedulazionePage";
import OstacoliPage from "./main/ostacoli/OstacoliPage";
import FasiFrazioniRepartoPage from "./main/reparti/FasiFrazioniRepartoPage";

export enum Routes_path {
	HOME = "/",
	SIGNIN = "/signin/",
	WELL_COME = "/well_come/:uidb64/:token/",
	FORGOT_PASSWORD = "/forgotPassword/",
	RESET_PASSWORD = "/resetPassword/:uidb64/:token/",
	UNDER_COSTRUCTION = "/UnderConstruction/",
	UTENTI = "/utenti/",
	UTENTE = "/utente/",
	TICKETING = "/tickets/",
	ODP_SEGUITI = "/opd_seguiti/",
	SCHEDULAZIONE = "/schedulazione/",
	OSTACOLI = "/ostacoli/",
	REPARTI = "/reparti/",
}

const RouterApp = () => {

	const isMaintenanceMode = false;
	if (isMaintenanceMode) {
		return <Navigate to={Routes_path.UNDER_COSTRUCTION} replace />;
	}

	return (
		<ScrollToTop>
			<Routes>
				<Route path={Routes_path.HOME} element={<HomePage />} />
				<Route path={Routes_path.SIGNIN} element={<SignIn />} />
				{/* <Route  path={"/register/"} element={Register} /> */}
				<Route path={Routes_path.WELL_COME} element={<WellComePage />} />
				<Route
					path={Routes_path.FORGOT_PASSWORD}
					element={<ForgotPassword />}
				/>
				<Route path={Routes_path.RESET_PASSWORD} element={<ResetPasswordPage />} />
				{/* <Route
					path={Routes_path.UNDER_COSTRUCTION}
					element={<UnderConstruction />}
				/> */}

				<Route
					path={Routes_path.ODP_SEGUITI}
					element={
						<PrivateRoute
							gruppiAutorizzati={[PermissionTypes.ALL]}
							element={<OdPLegacyPage />}
						/>
					}
				/>
				<Route
					path={Routes_path.UNDER_COSTRUCTION}
					element={
						<PrivateRoute
							gruppiAutorizzati={[PermissionTypes.GRUPPO_UNDERCONSTRUCTION]}
							element={<UnderConstruction />}
						/>
					}
				/>

				<Route
					path={Routes_path.SCHEDULAZIONE}
					element={
						<PrivateRoute
							gruppiAutorizzati={[PermissionTypes.ALL]}
							element={<SchedulazionePage />}
						/>
					}
				/>
				<Route
					path={Routes_path.OSTACOLI}
					element={
						<PrivateRoute
							gruppiAutorizzati={[PermissionTypes.ALL]}
							element={<OstacoliPage />}
						/>
					}
				/>
				<Route
					path={Routes_path.REPARTI}
					element={
						<PrivateRoute
							gruppiAutorizzati={[PermissionTypes.ALL]}
							element={<FasiFrazioniRepartoPage />}
						/>
					}
				/>
				<Route
					path={Routes_path.UNDER_COSTRUCTION}
					element={
						<PrivateRoute
							gruppiAutorizzati={[PermissionTypes.GRUPPO_UNDERCONSTRUCTION]}
							element={<UnderConstruction />}
						/>
					}
				/>


				<Route
					path="/me"
					element={
						<PrivateRoute
							gruppiAutorizzati={[PermissionTypes.ALL]}
							element={<ProfilePage />}
						/>
					}
				/>
				<Route
					path="/me/changepassword"
					element={
						<PrivateRoute
							gruppiAutorizzati={[PermissionTypes.ALL]}
							element={<ChangePassword />}
						/>
					}
				/>

				<Route
					path={Routes_path.TICKETING}
					element={
						<PrivateRoute
							gruppiAutorizzati={[PermissionTypes.TICKETING_ASSISTENZA]}
							element={<TicketsPage />}
						/>
					}
				/>

				<Route path="/notPermitted" element={<NotPermittedPage />} />
				<Route path="*" element={<NotFoundPage />} />
			</Routes>
		</ScrollToTop>
	);
};

export default RouterApp;
